// @flow
import styled from "styled-components"
import { Text } from "componentsStyled/Typography"

export const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  color: white;
  font-size: 1.7rem;
  margin: 0;
`



// WEBPACK FOOTER //
// ./src/components/ExploreButton/styled.js